import React from 'react';
import { motion } from 'framer-motion';
import { Shield, MapPin, CalendarCheck, Headphones } from 'lucide-react';
export function TrustSection() {
  const trustSignals = [{
    icon: <Shield className="w-6 h-6" data-id="element-159" />,
    text: 'DSGVO-konform'
  }, {
    icon: <MapPin className="w-6 h-6" data-id="element-160" />,
    text: 'Server in Deutschland'
  }, {
    icon: <CalendarCheck className="w-6 h-6" data-id="element-161" />,
    text: 'Monatlich kündbar'
  }, {
    icon: <Headphones className="w-6 h-6" data-id="element-162" />,
    text: 'Persönlicher Support'
  }];
  return <section className="py-12 bg-white border-b border-gray-100" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 mb-8" data-id="element-165">
          {trustSignals.map((signal, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-center text-gray-600" data-id="element-166">
              <div className="text-brand-accent mr-3" data-id="element-167">{signal.icon}</div>
              <span className="font-medium" data-id="element-168">{signal.text}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}